import { themes } from "./generated-new.mjs";
export { themes };
//# sourceMappingURL=themes.mjs.map
